<template>
  <div v-if="batchId && batchProgress" class="mr-2 d-flex align-items-center px-2 py-1 border rounded bg-light" style="min-width: 280px;">
    <small class="text-muted mr-2" style="white-space: nowrap; font-size: 0.875rem;">
      <i class="fas fa-cloud-upload-alt"></i> Envio SIAD
    </small>
    <div class="progress flex-grow-1" style="height: 6px;">
      <div 
        class="progress-bar progress-bar-striped" 
        :class="{
          'bg-success': batchProgress.finished && !batchProgress.failed_jobs,
          'bg-danger': batchProgress.failed_jobs > 0 || batchProgress.cancelled,
          'progress-bar-animated bg-primary': !batchProgress.finished && !batchProgress.cancelled
        }"
        role="progressbar" 
        :style="`width: ${batchProgress.progress}%`"
        :aria-valuenow="batchProgress.progress"
        aria-valuemin="0" 
        aria-valuemax="100">
      </div>
    </div>
    <span class="ml-2 badge badge-pill" :class="{
      'badge-success': batchProgress.finished && !batchProgress.failed_jobs,
      'badge-danger': batchProgress.failed_jobs > 0 || batchProgress.cancelled,
      'badge-primary': !batchProgress.finished && !batchProgress.cancelled
    }" style="min-width: 50px; font-size: 0.75rem;">
      <span v-if="batchProgress.failed_jobs > 0">
        <i class="fas fa-exclamation-triangle"></i> {{ batchProgress.failed_jobs }}
      </span>
      <span v-else-if="batchProgress.cancelled">
        <i class="fas fa-times-circle"></i>
      </span>
      <span v-else-if="batchProgress.finished">
        <i class="fas fa-check-circle"></i>
      </span>
      <span v-else>
        <i class="fas fa-spinner fa-spin"></i> {{ Math.round(batchProgress.progress) }}%
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SiadBatchProgress',
  
  props: {
    batchId: {
      type: [Number, String],
      default: null
    }
  },
  
  data() {
    return {
      batchProgress: null,
      timer: null
    };
  },
  
  watch: {
    batchId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.iniciarMonitoramento();
          });
        } else {
          this.pararMonitoramento();
        }
      }
    }
  },
  
  beforeDestroy() {
    this.pararMonitoramento();
  },
  
  methods: {
    consultarBatch() {
      if (!this.batchId) {
        return;
      }

      this.$util.atualizar(this, {
        service: 'integrador_siad',
        func: 'consultar_batch',
        dados: { 'id_batch': this.batchId },
        callback: (res) => {
          if (res) {
            this.batchProgress = res;
            
            if (res.finished || res.cancelled) {
              this.pararMonitoramento();
            }
          } else {
            this.batchProgress = null;
            this.pararMonitoramento();
          }
        },
      });
    },

    iniciarMonitoramento() {
      this.pararMonitoramento();
      
      this.consultarBatch();
      
      this.timer = setInterval(() => {
        this.consultarBatch();
      }, 5000);
    },

    pararMonitoramento() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>